import events from "../../events";
import * as fbq from "../../facebook-pixel/facebook-pixel";

const handleStartLearningEvent = ({
  source_screen,
  status,
  firebase_uid,
  webviewEvent,
}) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      firebase_uid,
      source_screen,
      status,
      date_time: new Date(),
    };
    if (webviewEvent) {
      eventParams.userAgent = webviewEvent?.userAgent;
      eventParams.webview = true;
    }
    window.dataLayer.push({
      event: events.start_learning_clicked,
      ...eventParams,
    });
    fbq.event(events.start_learning_clicked, eventParams);
  }
};

const handleAutoReadOtpEvent = ({ source_screen, status, webviewEvent }) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      source_screen,
      status,
      date_time: new Date(),
    };
    if (webviewEvent) {
      eventParams.userAgent = webviewEvent?.userAgent;
      eventParams.webview = true;
    }
    window.dataLayer.push({
      event: events.auto_read_otp_clicked,
      ...eventParams,
    });
    fbq.event(events.auto_read_otp_clicked, eventParams);
  }
};

const handleHamburgerClicked = ({ firebase_uid, screen, webviewEvent }) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      firebase_uid,
      screen,
      date_time: new Date(),
    };
    if (webviewEvent) {
      eventParams.userAgent = webviewEvent?.userAgent;
      eventParams.mobile = webviewEvent?.mobile;
      eventParams.webview = true;
    }
    window.dataLayer.push({
      event: events.hamburger_clicked,
      ...eventParams,
    });
    fbq.event(events.hamburger_clicked, eventParams);
  }
};

const handleWebPremiumBuyNowClickedEvent = ({ firebase_uid, webviewEvent }) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      firebase_uid,
      date_time: new Date(),
    };

    if (webviewEvent) {
      eventParams.packageName = webviewEvent?.packageName;
      eventParams.userAgent = webviewEvent?.userAgent;
      eventParams.mobile = webviewEvent?.mobile;
      eventParams.webview = true;
    }

    window.dataLayer.push({
      event: events.web_premium_buy_now_clicked,
      ...eventParams,
    });

    fbq.event(events.web_premium_buy_now_clicked, {
      firebase_uid,
      date_time: new Date(),
    });
  }
};

const handleViewRazorpayPaymentScreenEvent = ({
  firebase_uid,
  webviewEvent,
}) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      firebase_uid,
      date_time: new Date(),
    };

    if (webviewEvent) {
      eventParams.packageName = webviewEvent?.packageName;
      eventParams.userAgent = webviewEvent?.userAgent;
      eventParams.mobile = webviewEvent?.mobile;
      eventParams.webview = true;
    }
    window.dataLayer.push({
      event: events.web_premium_razorpay_dialog_viewed,
      ...eventParams,
    });

    fbq.event(events.web_premium_razorpay_dialog_viewed, eventParams);
  }
};

const handlePaymentModeSelectedEvent = ({
  firebase_uid,
  webviewEvent,
  source_screen,
  status,
}) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      firebase_uid,
      source_screen,
      date_time: new Date(),
      status,
    };

    if (webviewEvent) {
      eventParams.userAgent = webviewEvent?.userAgent;
      eventParams.mobile = webviewEvent?.mobile;
      eventParams.webview = true;
    }
    window.dataLayer.push({
      event: events.payment_mode_selected,
      ...eventParams,
    });

    fbq.event(events.payment_mode_selected, eventParams);
  }
};

const handlePaymentSuccessEvent = ({ firebase_uid, order_id, amount }) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      firebase_uid,
      date_time: new Date(),
      payment_order_id: order_id,
      amount,
    };
    window.dataLayer.push({
      event: events.web_premium_razorpay_payment_successful,
      ...eventParams,
    });
    fbq.event(events.web_premium_razorpay_payment_successful, eventParams);
  }
};

const handleClickedSkipEvent = ({ firebase_uid, webviewEvent }) => {
  window.dataLayer = window.dataLayer || [];
  const eventParams = {
    firebase_uid,
    // source_screen: "premium",
    status: "Clicked on Skip ",
  };
  if (webviewEvent) {
    eventParams.packageName = webviewEvent?.packageName;
    eventParams.userAgent = webviewEvent?.userAgent;
    eventParams.mobile = webviewEvent?.mobile;
    eventParams.webview = true;
  }
  window.dataLayer?.push({
    event: events.web_premium_skip_button_clicked,
    ...eventParams,
  });
  fbq.event(events.web_premium_skip_button_clicked, eventParams);
};

const handleLoginPageViewedEvent = ({
  firebase_uid,
  webviewEvent,
  source_screen,
}) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      firebase_uid,
      source_screen,
      date_time: new Date(),
    };
    if (webviewEvent) {
      eventParams.packageName = webviewEvent?.packageName;
      eventParams.userAgent = webviewEvent?.userAgent;
      eventParams.webview = true;
    }
    window.dataLayer?.push({
      event: events.login_page_viewed,
      ...eventParams,
    });
    fbq.event(events.login_page_viewed, eventParams);
  }
};

const handlePremiumSeriesPopUpEvent = ({
  firebase_uid,
  source_screen,
  seriesId,
  status,
  webviewEvent,
}) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      firebase_uid,
      source_screen,
      series_ki_id: seriesId,
      status,
    };
    if (webviewEvent) {
      eventParams.userAgent = webviewEvent?.userAgent;
      eventParams.mobile = webviewEvent?.mobile;
      eventParams.webview = true;
    }
    window.dataLayer.push({
      event: events.web_premium_series_popup,
      ...eventParams,
    });
    fbq.event(events.web_premium_series_popup, eventParams);
  }
};

const handlePremiumSeriesClickedEvent = ({
  firebase_uid,
  source_screen,
  seriesId,
  webviewEvent,
}) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      firebase_uid,
      source_screen,
      series_ki_id: seriesId,
    };
    if (webviewEvent) {
      eventParams.userAgent = webviewEvent?.userAgent;
      eventParams.mobile = webviewEvent?.mobile;
      eventParams.webview = true;
    }
    window.dataLayer.push({
      event: events.web_premium_series_clicked,
      ...eventParams,
    });
    fbq.event(events.web_premium_series_clicked, eventParams);
  }
};

const handleSignInEvents = ({ firebase_uid, webviewEvent }) => {
  window.dataLayer = window.dataLayer || [];
  const eventParams = {
    firebase_uid,
    date_time: new Date(),
  };
  if (webviewEvent) {
    eventParams.packageName = webviewEvent?.packageName;
    eventParams.userAgent = webviewEvent?.userAgent;
    eventParams.mobile = webviewEvent?.mobile;
    eventParams.webview = true;
  }
  window.dataLayer.push({
    event: events.web_premium_otp_screen_viewed,
    ...eventParams,
  });
  fbq.event(events.web_premium_otp_screen_viewed, eventParams);
};

const handleClickedContinueAndOTPScreenViewed = ({
  firebase_uid,
  webviewEvent,
}) => {
  window.dataLayer = window.dataLayer || [];
  const eventParams = {
    firebase_uid,
    date_time: new Date(),
  };
  if (webviewEvent) {
    eventParams.packageName = webviewEvent?.packageName;
    eventParams.userAgent = webviewEvent?.userAgent;
    eventParams.mobile = webviewEvent?.mobile;
    eventParams.webview = true;
  }

  window.dataLayer.push({
    event: events.web_premium_login_continue_clicked,
    ...eventParams,
  });

  window.dataLayer.push({
    event: events.web_premium_otp_screen_viewed,
    ...eventParams,
  });

  fbq.event(events.web_premium_otp_screen_viewed, eventParams);
};

const handleLoginSuccessEvent = ({ firebase_uid, webviewEvent }) => {
  window.dataLayer = window.dataLayer || [];
  const eventParams = {
    firebase_uid,
    date_time: new Date(),
  };
  if (webviewEvent) {
    eventParams.packageName = webviewEvent?.packageName;
    eventParams.userAgent = webviewEvent?.userAgent;
    eventParams.mobile = webviewEvent?.mobile;
    eventParams.webview = true;
  }
  window.dataLayer.push({
    event: events.web_premium_login_successful,
    ...eventParams,
  });
  fbq.event(events.web_premium_login_successful, eventParams);
};

const handleWebTrueCallerLoginEvent = ({
  firebase_uid,
  webviewEvent,
  status,
  source_screen,
}) => {
  window.dataLayer = window.dataLayer || [];
  const eventParams = {
    firebase_uid,
    date_time: new Date(),
    status,
    source_screen,
  };
  if (webviewEvent) {
    eventParams.userAgent = webviewEvent?.userAgent;
    eventParams.webview = true;
  }
  window.dataLayer.push({
    event: events.web_truecaller_login,
    ...eventParams,
  });
  fbq.event(events.web_truecaller_login, eventParams);
};

const handleAppStoreDownloadClicked = ({ firebase_uid, status }) => {
  window.dataLayer = window.dataLayer || [];
  const eventParams = {
    firebase_uid,
    date_time: new Date(),
    status,
  };
  window.dataLayer.push({
    event: events.app_store_download_clicked,
    ...eventParams,
  });
  fbq.event(events.app_store_download_clicked, eventParams);
};

const handleRefundContactUsClickedEvent = ({ firebase_uid, status }) => {
  window.dataLayer = window.dataLayer || [];
  const eventParams = {
    firebase_uid,
    date_time: new Date(),
    status,
  };
  window.dataLayer.push({
    event: events.refund_contact_button_clicked,
    ...eventParams,
  });
  fbq.event(events.refund_contact_button_clicked, eventParams);
};

const handleBlogDownloadBannerEvent = ({ status, sourceScreen, blogTitle }) => {
  window.dataLayer = window.dataLayer || [];
  const eventParams = {
    date_time: new Date(),
    blog_title: blogTitle,
    source_screen: sourceScreen,
    status,
  };
  window.dataLayer.push({
    event: events.blog_download_banner,
    ...eventParams,
  });
  fbq.event(events.blog_download_banner, eventParams);
};

const handleDownloadAppClickedEvent = ({
  firebaseUID,
  desktopStatus,
  mobileStatus,
  sourceScreen,
  anonymousId,
}) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      firebase_uid: firebaseUID,
      date_time: new Date(),
      desktop_status: desktopStatus,
      mobile_status: mobileStatus,
      source_screen: sourceScreen,
      anon_id: anonymousId,
    };
    window.dataLayer.push({
      event: events.download_app_clicked,
      ...eventParams,
    });
    fbq.event(events.download_app_clicked, eventParams);
  }
};

const handleDownloadAppQRViewedEvent = ({
  status,
  sourceScreen,
  sourceSection,
}) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      date_time: new Date(),
      status,
      source_section: sourceSection,
      source_screen: sourceScreen,
    };
    window.dataLayer.push({
      event: events.download_app_qr_viewed,
      ...eventParams,
    });
    fbq.event(events.download_app_qr_viewed, eventParams);
  }
};

const handleEppoAssignmentLogEvent = ({
  subject,
  variation_name,
  experiment_id,
  holdout_key,
  holdout_variation,
}) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      date_time: new Date(),
      subject,
      variation_name,
      experiment_id,
      holdout_key,
      holdout_variation,
    };
    window.dataLayer.push({
      event: events.eppo_assignment_log,
      ...eventParams,
    });
    fbq.event(events.eppo_assignment_log, eventParams);
  }
};

const handleFiveSecTimeSpentEvent = ({ userId, firebaseUID, sourceScreen }) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      user_id: userId,
      firebase_uid: firebaseUID,
      date_time: new Date(),
      source_screen: sourceScreen,
    };
    window.dataLayer.push({
      event: events.five_sec_time_spent,
      ...eventParams,
    });
    fbq.event(events.five_sec_time_spent, eventParams);
  }
};

const handleCategoryPillClickedEvent = ({
  firebaseUID,
  category,
  sourceScreen,
  anonymousId,
}) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      firebase_uid: firebaseUID,
      date_time: new Date(),
      category_name: category,
      source_screen: sourceScreen,
      anon_id: anonymousId,
    };
    window.dataLayer.push({
      event: events.category_pill_clicked,
      ...eventParams,
    });
    fbq.event(events.category_pill_clicked, eventParams);
  }
};

const handleLPVideoClickedEvent = ({
  firebaseUID,
  video_name,
  category,
  sourceScreen,
  anonymousId,
}) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      firebase_uid: firebaseUID,
      date_time: new Date(),
      video_name,
      category_name: category,
      source_screen: sourceScreen,
      anon_id: anonymousId,
    };
    window.dataLayer.push({
      event: events.lp_video_clicked,
      ...eventParams,
    });
    fbq.event(events.lp_video_clicked, eventParams);
  }
};

const handleFoldTriggeredEvent = ({
  firebaseUID,
  fold,
  sourceScreen,
  anonymousId,
}) => {
  if (window) {
    window.dataLayer = window.dataLayer || [];
    const eventParams = {
      firebase_uid: firebaseUID,
      date_time: new Date(),
      fold,
      source_screen: sourceScreen,
      anon_id: anonymousId,
    };
    window.dataLayer.push({
      event: events.fold_triggered,
      ...eventParams,
    });
    fbq.event(events.fold_triggered, eventParams);
  }
};

export {
  handleStartLearningEvent,
  handleAutoReadOtpEvent,
  handleHamburgerClicked,
  handleWebPremiumBuyNowClickedEvent,
  handleViewRazorpayPaymentScreenEvent,
  handlePaymentModeSelectedEvent,
  handlePaymentSuccessEvent,
  handleClickedSkipEvent,
  handleLoginPageViewedEvent,
  handlePremiumSeriesPopUpEvent,
  handlePremiumSeriesClickedEvent,
  handleSignInEvents,
  handleClickedContinueAndOTPScreenViewed,
  handleLoginSuccessEvent,
  handleWebTrueCallerLoginEvent,
  handleAppStoreDownloadClicked,
  handleRefundContactUsClickedEvent,
  handleBlogDownloadBannerEvent,
  handleDownloadAppClickedEvent,
  handleDownloadAppQRViewedEvent,
  handleEppoAssignmentLogEvent,
  handleFiveSecTimeSpentEvent,
  handleCategoryPillClickedEvent,
  handleLPVideoClickedEvent,
  handleFoldTriggeredEvent,
};
